import { apiPost } from '.';

export async function onboardHost(userId: string, redirectUrl: string): Promise<{ url: string }> {
  return apiPost(`/ext/stripe/onboard-host`, {
    redirectUrl,
    userId,
  });
}

export async function onboardProperty(
  propertyId: string,
  redirectUrl: string
): Promise<{ url: string }> {
  return apiPost(`/ext/stripe/onboard-property`, {
    redirectUrl,
    propertyId,
  });
}

export async function viewHostDashboard(userId: string): Promise<{ url: string }> {
  return apiPost(`/ext/stripe/dashboard-host`, {
    userId,
  });
}

export async function viewPropertyDashboard(propertyId: string): Promise<{ url: string }> {
  return apiPost(`/ext/stripe/dashboard-property`, {
    propertyId,
  });
}
